import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import parsePostContent from '../../common/helpers/parsePostContent';
/** System post for "draw by agreement". Type: arenaBattleDraw. */
export default class ArenaBattleDrawPost extends Component {
  view() {
    const data = parsePostContent(this.attrs.post.content());
    if (!data) return null;
    return m("div", {
      className: "ArenaFinalPost ArenaFinalPost--draw EventPost"
    }, m("div", {
      className: "ArenaFinalPost-icon"
    }, m("i", {
      className: "fas fa-handshake"
    })), m("div", {
      className: "ArenaFinalPost-body"
    }, m("div", {
      className: "ArenaFinalPost-title"
    }, app.translator.trans('forumaker-arena.forum.battle_draw.title')), m("div", {
      className: "ArenaFinalPost-subtitle"
    }, app.translator.trans('forumaker-arena.forum.battle_draw.subtitle'))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleDrawPost', ArenaBattleDrawPost);